export function uniq<I>(items: I[]): I[] {
    return items.reduce((p: I[], v: I) => {
        if (p.indexOf(v) < 0) {
            p.push(v);
        }
        return p;
    }, []);
}
